import React, { useEffect, useRef, useState } from 'react';
import {
  Map as LeafletMap,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  withLeaflet,
} from 'react-leaflet';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import markerGuto from 'assets/img/marker-guto.png';
import { useDispatch, useSelector } from 'react-redux';
import ErrorModal from 'pages/Convocations/components/ErrorModal';
import LoadingModal from 'pages/Convocations/components/LoadingModal';
import 'leaflet/dist/leaflet.css';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

// Função para criar ícone customizado
const createCustomIcon = (iconUrl, iconSize = [22, 32]) => {
  return L.icon({
    iconUrl: iconUrl,
    iconSize: iconSize,
    iconAnchor: [iconSize[0] / 2, iconSize[1]],
    popupAnchor: [0, -iconSize[1]],
  });
};

// Ícone customizado para caminhão usando marker-guto.png
const VehicleIcon = L.icon({
  iconUrl: markerGuto,
  iconSize: [32, 40],
  iconAnchor: [16, 16],
  popupAnchor: [0, -16],
});


// Componente para ajustar o zoom do mapa
function MapControllerBase({ center, zoom, leaflet }) {
  const map = leaflet?.map;

  useEffect(() => {
    if (
      map &&
      center &&
      center.lat !== undefined &&
      center.lng !== undefined
    ) {
      map.setView([center.lat, center.lng], zoom || map.getZoom());
    }
  }, [center, zoom, map]);

  return null;
}
const MapController = withLeaflet(MapControllerBase);

export const MapWithAMarker = ({
  paths,
  cte,
  invoices,
  convocation,
  specificInvoice,
  loading,
  getPaths,
  handleOpenPopover,
  handleOpenMarker,
  truckerLocation,
  closeModalError,
  trips = [], // Viagens relacionadas à carga
  trackingData = [], // Dados de rastreamento do veículo
}) => {
  const dispatch = useDispatch();
  const { modalDelete, centerMap, messageModal, acceptDelete } =
    useSelector((state) => state.convocations);
  const { cte: cteRedux } = useSelector((state) => state.cte);
  const { actualMarkerTrucker } = useSelector((state) => state.trucker);

  const [firstLocation, setFirstLocation] = useState(null);
  const [locationTrucker, setLocationTrucker] = useState(null);
  const [locations, setLocations] = useState(paths);
  const [markers, setMarkers] = useState(invoices);
  const [activeInvoice, setActiveInvoice] = useState(null);

  function calcDist(location1, location2) {
    let R = 6371;
    let dLat = (location2.lat - location1.lat) * (Math.PI / 180);
    let dLon = (location2.lng - location1.lng) * (Math.PI / 180);

    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(location1.lat * (Math.PI / 180)) *
        Math.cos(location2.lat * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;

    return d;
  }

  const checkIfHaveActiveInvoice = () => {
    if (invoices) {
      const orderedInvoices = invoices.sort(
        (inv1, inv2) =>
          calcDist(
            {
              lat: inv1?.data?.lat || inv1?.receiver?.lat,
              lng: inv1?.data?.lng || inv1?.receiver?.lng,
            },
            {
              lat: truckerLocation.latitude,
              lng: truckerLocation.longitude,
            }
          ) -
          calcDist(
            {
              lat: inv2?.data?.lat || inv2?.receiver?.lat,
              lng: inv2?.data?.lng || inv2?.receiver?.lng,
            },
            {
              lat: truckerLocation.latitude,
              lng: truckerLocation.longitude,
            }
          )
      );

      if (cte.activeInvoice == null) {
        const data = {
          ...cte,
          activeInvoice:
            orderedInvoices[0] != null ? orderedInvoices[0] : null,
          updated_at: new Date(),
        };

        // TODO: Atualizar para usar API REST ao invés de Firebase
        console.log('Atualizar activeInvoice:', data);
      }
    }
  };

  const getLastLocation = () => {
    if (locationTrucker == null) {
      setFirstLocation({
        lat: truckerLocation.latitude,
        lng: truckerLocation.longitude,
      });
    }
    if (truckerLocation) {
      setLocationTrucker({
        lat: truckerLocation.latitude,
        lng: truckerLocation.longitude,
      });
    }
  };

  function invoiceMarker(invoice) {
    if (invoice) {
      if (invoice.signature && invoice.status === 'completed') {
        return createCustomIcon(
          'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin-green-checked.png?alt=media&token=29585f05-c839-45a5-a084-f825ac6061aa',
          [28, 32]
        );
      } else {
        return createCustomIcon(
          'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin-green.png?alt=media&token=d3ce9acc-edff-473b-900c-43ab09540daf',
          [22, 32]
        );
      }
    } else {
      return createCustomIcon(
        'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin-green.png?alt=media&token=d3ce9acc-edff-473b-900c-43ab09540daf',
        [22, 32]
      );
    }
  }

  function convocationMarker(type) {
    if (convocation) {
      if (
        convocation.status === 'arrived_requester' ||
        convocation.status === 'in_progress_res' ||
        convocation.status === 'completed'
      ) {
        const iconUrl =
          convocation.status === 'completed' && type === 'delivery'
            ? 'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin-green-checked.png?alt=media&token=29585f05-c839-45a5-a084-f825ac6061aa'
            : type === 'delivery'
            ? 'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin-green.png?alt=media&token=d3ce9acc-edff-473b-900c-43ab09540daf'
            : 'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin-blue-checked.png?alt=media&token=01b411bd-5429-42ca-a71b-bc0b38834223';
        return createCustomIcon(iconUrl, [28, 32]);
      } else {
        const iconUrl =
          type === 'collect'
            ? 'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin-blue.png?alt=media&token=509e1c65-3633-42ee-87b3-4bbf89098219'
            : 'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin-green.png?alt=media&token=d3ce9acc-edff-473b-900c-43ab09540daf';
        return createCustomIcon(iconUrl, [22, 32]);
      }
    } else {
      const iconUrl =
        type === 'collect'
          ? 'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin-blue.png?alt=media&token=509e1c65-3633-42ee-87b3-4bbf89098219'
          : 'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin-green.png?alt=media&token=d3ce9acc-edff-473b-900c-43ab09540daf';
      return createCustomIcon(iconUrl, [22, 32]);
    }
  }

  useEffect(() => {
    if (invoices != null && cte != null && cte.activeInvoice == null) {
      checkIfHaveActiveInvoice();
    }
  }, []);

  useEffect(() => {
    getLastLocation();
  }, [truckerLocation]);

  useEffect(() => {
    if (cte != null && cte.activeInvoice != null) {
      setActiveInvoice(cte.activeInvoice);
    }
  }, [cte]);

  useEffect(() => {
    if (paths && paths.length > 0) {
      setMarkers(invoices);
      setLocations(paths);
      if (invoices != null) {
        setActiveInvoice(invoices[0]);
      }
    } else {
      setLocationTrucker(null);
      setLocations([]);
      setMarkers([]);
    }
  }, [paths, invoices]);

  // Coordenadas do centro do Brasil (fallback)
  const centerBrasil = { lat: -14.2350, lng: -51.9253 };
  
  // Limites restritivos do território brasileiro (apenas Brasil, sem países vizinhos)
  const maxBounds = [
    [4.5, -74.0], // Sudoeste (canto inferior esquerdo)
    [-33.5, -34.0] // Nordeste (canto superior direito)
  ];

  // Calcular centro do mapa
  const getMapCenter = () => {
    if (centerMap) {
      return { lat: centerMap.lat, lng: centerMap.lng };
    }
    if (truckerLocation && truckerLocation.latitude && truckerLocation.longitude) {
      return { lat: truckerLocation.latitude, lng: truckerLocation.longitude };
    }
    if (convocation && convocation.collect_lat && convocation.collect_lng) {
      return { lat: convocation.collect_lat, lng: convocation.collect_lng };
    }
    return centerBrasil;
  };

  const mapCenter = getMapCenter();

  // Preparar coordenadas para Polyline (rota)
  const polylinePositions = locations && locations.length > 0
    ? locations.map(loc => [loc.lat, loc.lng])
    : [];

  return (
    <>
      {truckerLocation ? (
        !loading ? (
          locations != null && truckerLocation != null ? (
            <LeafletMap
              center={[mapCenter.lat, mapCenter.lng]}
              zoom={6}
              minZoom={4}
              maxZoom={18}
              maxBounds={maxBounds}
              maxBoundsViscosity={1.0}
              style={{ height: '100%', width: '100%' }}
              scrollWheelZoom={true}
            >
              <MapController center={mapCenter} zoom={6} />
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              
              {/* Rota (Polyline) */}
              {polylinePositions.length > 1 && (
                <Polyline
                  positions={polylinePositions}
                  color="#2A5BA8"
                  weight={4}
                  opacity={0.7}
                />
              )}

              {/* Marcador do Motorista */}
              {locationTrucker && (
                <Marker
                  position={[locationTrucker.lat, locationTrucker.lng]}
                  icon={createCustomIcon(
                    'https://firebasestorage.googleapis.com/v0/b/manifestoonline-dd357.appspot.com/o/makers%2Fpin_mol.png?alt=media&token=a3562480-ac22-4879-bef1-a92c90975b57',
                    [21.82, 42]
                  )}
                  onClick={() => {
                    if (handleOpenPopover) {
                      handleOpenPopover({
                        latLng: {
                          lat: () => locationTrucker.lat,
                          lng: () => locationTrucker.lng,
                        },
                      });
                    }
                  }}
                >
                  <Popup>Localização do Motorista</Popup>
                </Marker>
              )}

              {/* Marcador de Coleta */}
              {convocation && convocation.collect_lat && convocation.collect_lng && (
                <Marker
                  position={[convocation.collect_lat, convocation.collect_lng]}
                  icon={convocationMarker('collect')}
                >
                  <Popup>Ponto de Coleta</Popup>
                </Marker>
              )}

              {/* Marcador de Entrega */}
              {!specificInvoice &&
                convocation &&
                convocation.delivery_lat &&
                convocation.delivery_lng &&
                convocation.collect_lat !== convocation.delivery_lat &&
                convocation.collect_lng !== convocation.delivery_lng && (
                  <Marker
                    position={[convocation.delivery_lat, convocation.delivery_lng]}
                    icon={convocationMarker('delivery')}
                  >
                    <Popup>Ponto de Entrega</Popup>
                  </Marker>
                )}

              {/* Marcadores de Rastreamento (Última Posição do Veículo) */}
              {trackingData && trackingData.length > 0 && trackingData.map((track, index) => {
                // Tentar diferentes formatos de latitude/longitude
                const lat = parseFloat(track.latitude || track.lat || 0);
                const lng = parseFloat(track.longitude || track.lng || 0);
                
                // Validar coordenadas
                if (isNaN(lat) || isNaN(lng) || lat === 0 || lng === 0) {
                  return null;
                }
                
                // Validar se está dentro de limites razoáveis (Brasil)
                if (lat < -35 || lat > 6 || lng < -75 || lng > -30) {
                  return null;
                }
                
                return (
                  <Marker
                    key={`track-${track.carga_id || track.id || index}`}
                    position={[lat, lng]}
                    icon={VehicleIcon}
                  >
                    <Popup>
                      <strong>🚚 Posição do Caminhão</strong>
                      <br />
                      Carga ID: {track.carga_id ? track.carga_id.substring(0, 8) + '...' : 'N/A'}
                      <br />
                      Motorista: {track.motorista_nome || 'N/A'}
                      <br />
                      Telefone: {track.motorista_telefone || 'N/A'}
                      <br />
                      {track.data_envio && (
                        <>
                          Última atualização: {new Date(track.data_envio).toLocaleString('pt-BR')}
                        </>
                      )}
                    </Popup>
                  </Marker>
                );
              })}

              {/* Marcadores de Destinatário (Local de Entrega) das Viagens da Carga Selecionada */}
              {trips && trips.length > 0 && trips.map((trip, index) => {
                  // Verificar se a viagem tem coordenadas do destinatário
                  const destinatarioLat = trip.destinatario?.lat || trip.destinatario_lat;
                  const destinatarioLng = trip.destinatario?.lng || trip.destinatario_lng;
                  
                  return (
                    <React.Fragment key={`trip-${trip.id || index}`}>
                      {/* Marcador do Destinatário (Local de Entrega) com ícone padrão de localização */}
                      {destinatarioLat && destinatarioLng && (
                        <Marker
                          position={[parseFloat(destinatarioLat), parseFloat(destinatarioLng)]}
                        >
                          <Popup>
                            <strong>Local de Entrega</strong>
                            <br />
                            Destinatário: {trip.destinatario?.nome_razao_social || trip.destinatario_nome || 'N/A'}
                            <br />
                            Viagem: {trip.referencia || trip.id || 'N/A'}
                            <br />
                            Status: {trip.status || 'N/A'}
                          </Popup>
                        </Marker>
                      )}
                    </React.Fragment>
                  );
                })}

              {/* Marcadores de Notas Fiscais */}
              {specificInvoice ? (
                <Marker
                  position={[
                    specificInvoice?.data?.lat || specificInvoice?.receiver?.lat,
                    specificInvoice?.data?.lng || specificInvoice?.receiver?.lng,
                  ]}
                  icon={invoiceMarker(specificInvoice)}
                  onClick={() => {
                    if (handleOpenMarker) {
                      handleOpenMarker({}, specificInvoice);
                    }
                  }}
                >
                  <Popup>Nota Fiscal: {specificInvoice?.number || 'N/A'}</Popup>
                </Marker>
              ) : (
                invoices &&
                invoices.map((invoice, index) => (
                  <Marker
                    key={index}
                    position={[
                      invoice?.data?.lat || invoice?.receiver?.lat,
                      invoice?.data?.lng || invoice?.receiver?.lng,
                    ]}
                    icon={invoiceMarker(invoice)}
                    onClick={() => {
                      if (handleOpenMarker) {
                        handleOpenMarker({}, invoice);
                      }
                    }}
                  >
                    <Popup>Nota Fiscal: {invoice?.number || 'N/A'}                    </Popup>
                  </Marker>
                ))
              )}
            </LeafletMap>
          ) : (
            <ErrorModal
              reload={() => getPaths()}
              onClose={closeModalError}
            />
          )
        ) : (
          <LoadingModal reload={() => {}} onClose={closeModalError} />
        )
      ) : (
        <LeafletMap
          center={[centerBrasil.lat, centerBrasil.lng]}
          zoom={5}
          minZoom={4}
          maxZoom={18}
          maxBounds={maxBounds}
          maxBoundsViscosity={1.0}
          style={{ height: '100%', width: '100%' }}
          scrollWheelZoom={true}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
        </LeafletMap>
      )}
    </>
  );
};

